<template>

   <v-flex pb-0 pt-1 v-bind="$attrs" v-if="uCanSee" xs12>
      <v-select :item-text="displayField" :item-value="displayKey"
                :items="items" :loading="isLoading" box class="clean-style"
                :placeholder="pholder"
                :rules="validationRules"
                :value="value"
                ref="selectField"
                v-bind="$attrs"
                v-on="listeners"
                validate-on-blur
      ></v-select>
   </v-flex>

</template>

<script>
   // import debounce from 'lodash.debounce';
   import Rules from './validationRules';

   export default {
      name: 'a-select-field',

      props: {
         value: {
            required: false
         },
         floating: {
            type: Boolean,
            required: false,
            default: false
         },
         suggestions: {
            type: Array,
            required: false
         },
         displayKey: {
            type: String,
            required: false,
            default: 'id'
         },
         displayField: {
            required: false,
            default: 'name'
         },
         api: {
            type: String,
            required: false,
            default: 'dataService'
         },
         obj: {
            type: String,
            required: false
         },
         filterBy: {
            type: Object,
            required: false
         },
         validate: {
            type: String,
            required: false
         },
         rid: {
            type: String,
            required: false
         },
         objMethod: {
            type: String,
            required: false
         },
         updateWithFilters: {
            type: Boolean,
            required: false,
            default: false
         }
      },

      data () {
         return {
            selectedItems: null,
            isLoading: false,
            items: [],
            uCanSee: true
         };
      },

      watch: {
         'suggestions' (newValue) {
            if (!this.items || !this.items.length) {
               this.items = newValue;
            }
         },
         async 'filterBy' (newValue, oldValue) {
            if(JSON.stringify(newValue) != JSON.stringify(oldValue) && !this.suggestions && this.updateWithFilters && this.obj){
               this.items = await this.getApiSuggestions(newValue);
               if(this.value && !(this.items.find(el=>el.id == this.value))) this.$emit('input', null);
            }
         },

         value: {
            handler: function (val) {
               this.$nextTick(() => this.setFromValue(val));
            },
            immediate: true
         }
      },

      computed: {
         objRoot () {
            return this.obj.split('/')[0];
         },

         pholder () {
            let prop = this.placeholder;
            return (this.floating) ? (prop || '') : (prop || ' ');
         },

         listeners () {
            return {
               ...this.$listeners,
               input: (data) => {
                  // console.log('ASelect Input Listener: ', data);
                  if (this.$attrs.hasOwnProperty('return-object') && this.$attrs.hasOwnProperty('multiple') && data && data.length) {
                     data.map((i, index) => {
                        if (['number', 'string'].indexOf(typeof i) >= 0 && this.items && this.items.length) {
                           let obj = this.items.filter(f => f[this.displayKey] == i);
                           if (obj.length) {
                              data[index] = obj[0];
                           }
                        }
                     });
                  }
                  // console.log('ASelect Treated Input: ', data);

                  this.selectedItems = JSON.stringify(data);
                  this.$emit('input', data);
               }
            };
         },

         validationRules () {
            let rules = [];

            if (this.validate) {
               let rulesArray = this.validate.split(',');
               rulesArray.forEach(r => rules.push(Rules[r.trim()]));
            }

            return rules;
         },
         
         forceValidation () {
            return this.$refs.selectField.validate;
         }
      },

      methods: {
         setFromValue (val) {
            let needConvertion = () => {
               if (['string', 'number'].indexOf(typeof val) > -1 && this.$attrs.hasOwnProperty('multiple')) {
                  return true;
               } else if (Array.isArray(val) && val.length && typeof val[0] !== 'object'
                          && this.$attrs.hasOwnProperty('multiple') && this.$attrs.hasOwnProperty('return-object')) {
                  return true;
               }

               return false;
            };

            let newEntry = (JSON.stringify(val) !== this.selectedItems);
            let value = val;

            // console.log(this.obj, newEntry, val, this.value);

            if (val && newEntry && this.$attrs.hasOwnProperty('multiple') && needConvertion()) {
               let keys;
               if (typeof val === 'string') {
                  keys = val.split(',').map(v => +v);
               } else if (Array.isArray(val)) {
                  keys = val;
               } else if (typeof val === 'number') {
                  keys = [val];
               }

               value = keys;

               if (keys && keys.length && this.$attrs.hasOwnProperty('return-object')) {
                  let selectedObjs = [];
                  keys.forEach(key => {
                     if (typeof key === 'number') {
                        let f = this.items.filter(f => f[this.displayKey] === +key);
                        if (f && f.length) {
                           let obj = {};
                           obj[this.displayKey] = +key;
                           obj[this.displayField] = f[0][this.displayField];
                           selectedObjs.push(obj);
                        }
                     } else {
                        selectedObjs.push(key);
                     }
                  });
                  // console.log('emit status: ', status);
                  value = selectedObjs;
               }

            }

            if (newEntry && value !== this.value) {
               this.$emit('input', value);
            }


         },

         getApiSuggestions (filters = null) {
            let params = Object.assign({}, filters ? filters : this.filterBy);
            if (this.obj) {
               if(this.objMethod){
                  return this.$api[this.api].getData(this.obj, params, this.objMethod);
               }
               return this.$api[this.api].search(this.obj, params);
            }
         },

         onFocus () {


         },

         onBlur () {

         }

      },

      async created() {
         if (!this.items || !this.items.length) {
            this.items = this.suggestions || await this.getApiSuggestions();
         }

         this.uCanSee = this.$uCan({
            rid: this.rid,
            op: 'S'
         });
      }
   };
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// node_modules/@consigmais-team/vue-common/components/ASelectField.vue